// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "bbc7e4ff7134e993f18b05b4df90dd5009b29ce1/static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"440":"486bdddc","581":"0843d95a","688":"2b6b0509","774":"772e6540"}[chunkId] + ".chunk.js";
};